<template>
  <li :class="classes" @click.stop="$_onMenuItemClick">
    <slot>
    </slot>
    <t-dropdown v-if="this.$slots.subNav" offset="-12px">
      <slot slot="trigger" name="title"></slot>
      <slot slot="popper" name="subNav"></slot>
    </t-dropdown>
  </li>
</template>
<script>
import { PREFIX_CLASS } from '../../utils/constants'
import { hasClass } from '@/utils/helper.js'
const PREFIX_MENU_CLASS = `${PREFIX_CLASS}navs`

export default {
  name: 'TNavsItem',
  inject: {
    groupVM: { default: null }
  },
  props: {
    name: {
      type: [String, Number],
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    stopChangeTab: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      active: false
    }
  },
  computed: {
    classes() {
      return [
        `${PREFIX_MENU_CLASS}__item`,
        {
          [`${PREFIX_MENU_CLASS}__item--checked`]: this.active,
          [`${PREFIX_MENU_CLASS}__item--disabled`]: this.disabled
        }
      ]
    }
  },
  mounted() {
    this.$on('on-update-active-name', name => {
      if (this.name === name) {
        if (hasClass(this.$el, 'd-none')) return
        this.active = true
      } else {
        this.active = false
      }
    })
  },
  created() {
    if (this.groupVM && this.groupVM.$options.name === 'TNavs') {
      this.groupVM.$_addItem(this)
    }
  },
  beforeDestroy() {
    if (this.groupVM && this.groupVM.$options.name === 'TNavs') {
      this.groupVM.$_removeItem(this)
    }
  },
  methods: {
    $_onMenuItemClick() {
      if (this.disabled || this.stopChangeTab) {
        return false
      }
      this.groupVM.$emit('menu-item-select', this.name)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/module/navs/navs-item.vue